import { useEffect } from 'react';
import { cancelTokenRefreshOnLogout } from 'services/auth/tokenBroker';
import { logoutClient } from 'shared/domain/logout/logoutClient';
import { useLogout } from 'components/core/WithLogout';
import { isLogoutFlowInProgress } from 'components/core/WithLogout/model';

/** Signs this tab out when the worker signed out (another tab, a 401). */
export function useLogoutSubscription(): void {
  const { logoutLocally } = useLogout();

  useEffect(() => {
    const stopListening = logoutClient.onLoggedOut(() => {
      // The tab that started the logout hears it too; it is already signing out
      // and keeps listening, in case it stays on the page.
      if (isLogoutFlowInProgress()) {
        return;
      }
      stopListening();
      cancelTokenRefreshOnLogout();
      logoutLocally();
    });
    return stopListening;
  }, [logoutLocally]);
}
